import { render } from "./approvalItemDetails.vue?vue&type=template&id=6ffc0918"
import script from "./approvalItemDetails.vue?vue&type=script&lang=js"
export * from "./approvalItemDetails.vue?vue&type=script&lang=js"

import "./approvalItemDetails.vue?vue&type=style&index=0&id=6ffc0918&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__